import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { postMABAA120 } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import { formatDate, formatNumberWithCommas } from '../../../utils';

const MABAA120 = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);

    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    useEffect(() => {
        postMABAA120(id, { page })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    }, [id, page]);

    return (
        <div className="profile-content">
            <div className="title-profile">덴탈잡 이용권 내역</div>
            <div id="profile-recent-recruitment">
                <div className="profile-content-count">
                    총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                </div>
                <table className="table-gray">
                    <thead>
                        <tr>
                            <th style={{ width: '8%' }}>신청일</th>
                            <th style={{ width: '6%' }}>결제Seq</th>
                            <th style={{ width: '8%' }}>채용광고Seq</th>
                            <th style={{ width: '30%' }}>
                                상품명
                                <br />
                                주문번호
                            </th>
                            <th style={{ width: '7%' }}>결제수단</th>
                            <th style={{ width: '7%' }}>
                                쿠폰번호
                                <br />
                                유효기간
                            </th>
                            <th style={{ width: '7%' }}>상태</th>
                            <th style={{ width: '7%' }}>사용여부</th>
                            <th style={{ width: '7%' }}>발송여부</th>
                            <th style={{ width: '11%' }}>교환쿠폰명</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((item, index) => {
                                return (
                                    <tr key={'recent-recruitment' + index}>
                                        <td>{formatDate(item?.purchaseDate)}</td>
                                        <td>{item?.paySeq}</td>
                                        <td>{item?.recSeq}</td>
                                        <td>
                                            {item?.goodName}
                                            <br />
                                            {item?.moid}
                                        </td>
                                        <td>덴탈이마트이용권</td>
                                        <td>
                                            {item?.ticketNum}
                                            {item?.paySeq}
                                            <br />
                                            {formatDate(item?.purchaseDate)}~{formatDate(item?.expiryDate)}
                                        </td>
                                        <td>대상아님</td>
                                        <td>
                                            사용완료
                                            <br />
                                            {item?.useDate ? formatDate(item?.useDate) : ''}
                                        </td>
                                        <td></td>
                                        <td>{item?.couponName}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr style={{ textAlign: 'center' }}>{<td colSpan={10}>데이타가 없습니다.</td>}</tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination pages={pages} />
        </div>
    );
};

export default MABAA120;
